
var state = {
	userinfo:'',

}
export default state



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js